import { css } from '@emotion/react'
import { Flow, Modal, ModalBody, ModalFooter, ModalFooterButton, ModalHeader } from 'bold-ui'
import { Form, FormRenderProps, PecFormApi, TextAreaField } from 'components/form'
import { metaPath } from 'util/metaPath'

import { JustificativaErrataNotaComplementarSelectField } from './components/JustificativaErrataNotaComplementarSelectField'
import { ErrataNotaComplementarModel } from './model-errataNotaComplementar'
import {
  DESCRICAO_ERRATA_NOTA_COMPLEMENTAR_MAX_LENGTH,
  validateErrataNotaComplementar,
} from './validator-errataNotaComplementar'

const meta = metaPath<ErrataNotaComplementarModel>()

interface ErrataNotaComplementarModalProps {
  open: boolean
  loading?: boolean
  onClose(): void
  onSubmit(values: ErrataNotaComplementarModel): Promise<void>
}

export function ErrataNotaComplementarModal(props: Readonly<ErrataNotaComplementarModalProps>) {
  const { open, loading, onClose, onSubmit } = props

  const handleFormSubmit = (values: ErrataNotaComplementarModel, form: PecFormApi<ErrataNotaComplementarModel>) => {
    return onSubmit(values).then(() => setTimeout(form.reset))
  }

  const renderForm = ({ handleSubmit, form }: FormRenderProps<ErrataNotaComplementarModel>) => {
    const handleClose = () => {
      form.reset()
      onClose()
    }

    return (
      <form noValidate>
        <Modal size='medium' open={open} onClose={handleClose}>
          <ModalHeader title='Registrar errata ou nota complementar' />
          <ModalBody>
            <Flow direction='vertical'>
              <div data-testid='errataJustificativa'>
                <JustificativaErrataNotaComplementarSelectField
                  label='Informe a justificativa:'
                  name={meta.justificativa}
                  required
                />
              </div>
              <div data-testid='errataComplemento'>
                <TextAreaField
                  label='Errata/Nota complementar:'
                  name={meta.descricao}
                  maxLength={DESCRICAO_ERRATA_NOTA_COMPLEMENTAR_MAX_LENGTH}
                  required
                  style={styles.textAreaField}
                />
              </div>
            </Flow>
          </ModalBody>
          <ModalFooter>
            <Flow direction='horizontal' justifyContent='flex-end'>
              <ModalFooterButton kind='normal' onClick={handleClose}>
                Cancelar
              </ModalFooterButton>
              <ModalFooterButton kind='primary' onClick={handleSubmit} loading={loading}>
                Salvar
              </ModalFooterButton>
            </Flow>
          </ModalFooter>
        </Modal>
      </form>
    )
  }

  return (
    <Form<ErrataNotaComplementarModel>
      render={renderForm}
      onSubmit={handleFormSubmit}
      validate={validateErrataNotaComplementar}
    />
  )
}

const styles = {
  textAreaField: css`
    height: 7rem;
    resize: none;
  `,
}
